import { Price, Link, Money } from "../models"

export class AdditionalCharge {
	storageId: number;
	uuid: string;
	pos: number;
	description: string;
	price: Price;

	public _links: {
		self: Link,
		deleteWithReference: Link
	}

	constructor() {
		this.price = new Price();
		this.price.money = new Money();
	}
}



// WEBPACK FOOTER //
// ./src/app/models/additional-charge.model.ts